import React from 'react';
import { ThemeProvider } from 'styled-components';
import { theme } from '../BeFi20.meta';
import { Output } from './Output';

export default () => (
  <ThemeProvider theme={theme}>
    <Output />
  </ThemeProvider>
);
